import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import App from './components/app'
import store, { history } from './store'
import { ConnectedRouter } from 'react-router-redux'
import { Route } from 'react-router'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import TagManager from 'react-gtm-module';
import ErrorBoundary from 'airbrake'
import './assets/style/index.css'
import './assets/style/bootstrap-theme.css'
// import registerServiceWorker from './registerServiceWorker'
import {unregister} from './registerServiceWorker';

import withTracker from './withTracker';
import {GOOGLE_TAG_MANAGER_API_KEY} from './data/googleTagManager';

const tagManagerArgs = {
  gtmId: GOOGLE_TAG_MANAGER_API_KEY
};

TagManager.initialize(tagManagerArgs);

render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Route component={withTracker(App)} />
      </ConnectedRouter>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js